import { SupportedPlatform } from 'ignite360-core';

/** In-memory draft handed from Feed cross-post to CMS Posts compose. */
export type CrossPostDraft = {
  botId: string;
  title: string;
  content: string;
  selectedPlatforms: SupportedPlatform[];
  images: { horizontal: File | null; square: File | null };
  video: File | null;
};

let pendingDraft: CrossPostDraft | null = null;

export function setCrossPostDraft(draft: CrossPostDraft): void {
  pendingDraft = draft;
}

/** Returns and clears the pending draft when it matches `botId` (if provided). */
export function takeCrossPostDraft(botId?: string): CrossPostDraft | null {
  if (!pendingDraft) {
    return null;
  }
  if (botId && pendingDraft.botId !== botId) {
    return null;
  }
  const draft = pendingDraft;
  pendingDraft = null;
  return draft;
}
